var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('navigation-cards'),_c('announcements-list'),_c('surveys-list'),_c('birthdays-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }